import * as React from 'react';
import * as styles from './MapWithPin.css';
import { Image, TImageObjectFit } from '../Image';
import { PinIcon } from './parts/PinIcon';

export interface IMapProps {
  alt?: string;
  src: string;
  fit?: TImageObjectFit;
}

export const MapWithPin = (props: IMapProps) => {
  const { alt, src, fit } = props;

  return (
    <div className={styles['map']}>
      <div className={styles['map-pin']}>
        <PinIcon />
      </div>
      <Image fit={fit} alt={alt} src={src} />
    </div>
  );
};
